import { motion } from "framer-motion";
import { WORLDS } from "@/lib/constants";
import { Reveal } from "./Reveal";
import { FloatingOrbs } from "./FloatingOrbs";

const dots = ["bg-lavender", "bg-ocean", "bg-green"];

export const Worlds = () => (
  <section id="voci" className="relative px-5 sm:px-8 lg:px-12 py-24 sm:py-32" data-testid="worlds">
    <FloatingOrbs />
    <div className="relative z-10 mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-12">
      {/* Images — affiancate, senza sovrapposizione */}
      <Reveal className="lg:col-span-7">
        <div className="mx-auto flex w-full max-w-2xl flex-col items-center gap-5 sm:flex-row sm:gap-6">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="w-full overflow-hidden rounded-[1.75rem] glass-strong p-2.5 animate-float sm:w-[58%]"
          >
            <img
              src={WORLDS.mermaid}
              alt="Le Cosplay Singers nel mondo di Mermaid Melody"
              className="aspect-square w-full rounded-[1.4rem] object-cover"
              data-testid="worlds-img-mermaid"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="w-full overflow-hidden rounded-[1.75rem] glass-strong p-2 animate-float-slow sm:w-[42%]"
          >
            <img
              src={WORLDS.magic}
              alt="Le Cosplay Singers nei mondi magici"
              className="aspect-[9/16] w-full rounded-[1.35rem] object-cover"
              data-testid="worlds-img-magic"
            />
          </motion.div>
        </div>
      </Reveal>

      {/* Text */}
      <Reveal delay={0.1} className="lg:col-span-5">
        <p className="mb-3 text-xs uppercase tracking-[0.3em] text-lavender-deep">I mondi che cantiamo</p>
        <h2 className="font-serif tracking-tightest text-3xl sm:text-4xl leading-[1.05] text-navy">
          Le voci ufficiali.
        </h2>
        <p className="mt-4 max-w-xs text-base leading-relaxed text-navy-soft">
          Diamo voce e il viso ad alcune delle canzoni più amate di sempre.
        </p>

        <ul className="mt-6 space-y-3">
          {WORLDS.titles.map((t, i) => (
            <li key={t} className="flex items-center gap-3" data-testid={`worlds-title-${i}`}>
              <span className={`h-2 w-2 shrink-0 rounded-full ${dots[i % dots.length]}`} />
              <span className="font-serif text-xl sm:text-2xl text-navy">{t}</span>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
